import axios from "@/axios.js";
import Tags from "./tags_service";

export default {
  getAllTags({ commit }, item) {
    return new Promise((resolve, reject) => {
      Tags.getAllTags(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  fetchTags(context, tagId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/tags/tags/${tagId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchAllTagsWithSalesDeveloperId(context, salesDeveloperId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/tags/tags/tags_by_sales_developer_id/${salesDeveloperId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeTag(context, tagId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/tags/tags/${tagId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getExistingTagLists(context, tag_from) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/tags/tags/get_existing_tag_lists/${tag_from}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  searchExistingTagLists(context, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/tags/tags/search_existing_tag_lists", {
          item: item
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateTags({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/tags/tags/update_tag", {
          item: item
        })
        .then(response => {
        
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addTags({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/tags/tags/add_tags", {
          item: item
        })
        .then(response => {
  
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeTags({ commit }, tagId) {
    return new Promise((resolve, reject) => {
      // alert(roleId)
      axios
        .delete(`/api/tags/tags/${tagId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
